import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, createElement } from "lwc";
import _tmpl from "./pdfViewerToolbar.html";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import LightningElementSLDS from 'util/lightningElementSLDS';
import { eventTypes, fireEvent, unregisterListener, registerListenerAndTrack } from 'util/pubsub';
//import { initializeGapi, handleAuthClickOAuth2, createPicker, revokeGoogleDriveAccess, getIsSignedIntoGoogle, fileUpload, exportWalletToZPaperDrive, importWalletFromZPaperDrive } from 'util/googleDrivePicker';
import { createCloudWatchObject, getNextSequenceToken, sendLogsToAws, saveLogs } from 'util/awsCloudwatch';
import { openSidebar, closeSidebar, addChildToSidebar, clearSidebar, getSidebarDom } from '../app/appUtil';

//import functions to be passed on to the zpLib

//import components that are to be passed on to the zpLib
import zPaperPageButtons from 'zpaper/pageButtons'; //page switch buttons
import zPaperZoomButtons from 'zpaper/zoomButtons'; //zoom buttons
//import zPaperUploadFileButton from ''; //zoom buttons
import zPaperToolbarButton from 'zpaper/toolbarButton'; //generic toolbar buttons
//import zPaperPersonas from 'zpaper/personas';//component to display and edit personas
import zPaperEditDropDown from 'zpaper/editDropDown'; //component to display and edit personas
import zPaperAttachFiles from 'zpaper/attachFiles'; //component to display attach panel
import zPaperMenuButton from 'zpaper/toolbarButtonMenu'; // dropdown menu button
import zPaperPanels from 'zpaper/panels'; //component to display panel list
import zPaperPagesPicker from 'zpaper/pagesPicker'; // select page thumbnails

//import components that can be used inside the toolbars
import jsonPathPicker from 'util/jsonPathPicker'; //input with autocomplete for nested object paths

//import standard lightning components
import lightningCombobox from 'lightning/combobox';
import lightningButton from 'lightning/button';
import lightningButtonIcon from 'lightning/buttonIcon';
class PdfViewerToolbar extends LightningElementSLDS {
  constructor() {
    super();
    //ahs - Add jQuery UI stype start
    // let jQueryUICSS = 'https://code.jquery.com/ui/1.13.1/themes/redmond/jquery-ui.css';
    // ORV240924 remove jquery_ui
    /*  let jQueryUICSS = 'resources/jQuery/jquery_ui.min.css';
      const jQueryUIStyles = document.createElement('link');
      jQueryUIStyles.href = jQueryUICSS;
      jQueryUIStyles.rel = 'stylesheet';
      this.template.appendChild(jQueryUIStyles); */
    //ahs - Add jQuery UI stype end

    //ahs - Add slick stype start //ORV240923 slick not in user commenting it out
    /*let slickCSS = 'resources/slick/slick.css';
    const slickStyles = document.createElement('link');
    slickStyles.href = slickCSS;
    slickStyles.rel = 'stylesheet';
    this.template.appendChild(slickStyles);
     let slickThemeCSS = 'resources/slick/slick_theme.css';
    const slickThemeStyles = document.createElement('link');
    slickThemeStyles.href = slickThemeCSS;
    slickThemeStyles.rel = 'stylesheet';
    this.template.appendChild(slickThemeStyles);*/
    //ahs - Add slick stype end

    //ahs - Add zpLib stype start
    this.pdfPage = void 0;
    this.pdfPageOverlay = void 0;
    this.pageRef = {
      attributes: {
        "developer": "zPaper",
        "application": "Document Viewer"
      }
    };
    this.donotUseNodeRed = false;
    let zpLibCSS = 'resources/zpLib/zpLib.css';
    const zpLibStyles = document.createElement('link');
    zpLibStyles.href = zpLibCSS;
    zpLibStyles.rel = 'stylesheet';
    this.template.appendChild(zpLibStyles);
    //ahs - Add zpLib stype end
  }
  connectedCallback() {
    window.__g_toolbarTemplate = this.template; //ORV240827 do we need window.__g_toolbarTemplate ask Cory
    console.log("PdfViwerToolbar");
    console.log($(".pdfPage"));
    console.log($(".pdfPageOverlay"));
    console.log($(".container"));
    console.log("pdfPage length : " + $(".pdfPage").length);
    console.log("pdfPageOverlay length : " + $(".pdfPageOverlay").length);
    console.log("container length : " + $(".container").length);
  }
  async initializeZpLib(params) {
    clearSidebar();
    closeSidebar("left");
    closeSidebar("right");
    console.log("initializeZpLib start");
    let self = this;
    //ORV store deskTopToolbar so it can be used to switch between toolbars when desktop view
    __g_zPDF_formHelper__.deskTopToolbar = $(this.template.querySelector(".toolbarWrapper"));
    let getJson = async url => {
      // let endpoint = getEndpoint(); // this is commented as it is not in use
      // let fullUrl = getFullUrl(url); // this is commented as it is not in use
      let jsonData = {};
      //AHS230124 - adding sf auth headers here
      let headers = {
        "Access-Control-Allow-Origin": "*",
        "Accept": "application/json"
      };
      headers = _objectSpread(_objectSpread({}, getDefaultHeaders()), headers);
      let ajaxSettings = {
        // "url": endpoint + fullUrl,
        "url": url,
        //using relative url to fetch json files
        "method": "GET",
        "async": false,
        "crossDomain": true,
        "headers": headers,
        success: data => {
          if (data) {
            jsonData = typeof data == "string" ? JSON.parse(data) : data;
          }
        },
        error: (jqxhr, status, error) => {
          console.log("An error has occured while loading external js, error", error, "status", status, "jqxhr", jqxhr);
        }
      };
      await $.ajax(ajaxSettings);
      return jsonData;
    };
    let jsonPathPrefix = "resources/configFiles/";
    let toolbarConfigInfoURL = jsonPathPrefix + "toolbars.json";

    //AHS240214 - get toolbars.json from __g_zToolbarsURL, if it is defined
    if (__g_zToolbarsURL && !this.donotUseNodeRed) {
      toolbarConfigInfoURL = __g_zToolbarsURL;
    }
    let toolbarConfigInfo = await getJson(toolbarConfigInfoURL);
    if (params.nonPdfFile) {
      let zPaperToolbarButtons = {};
      console.log("TestingDefaultPDF ** ");
      let openButton = await getJson(jsonPathPrefix + toolbarConfigInfo.basicToolbar);
      zPaperToolbarButtons = {
        "Open": openButton
      };
      $(params.pdfPage).zpLib({
        action: "initilizeToolbar",
        buttons: zPaperToolbarButtons,
        toolbarWrapper: this.template.querySelector(".toolbarWrapper")
      });
    } else if (params.htmlFile) {
      let htmlToolbarConfigInfo = await getJson(jsonPathPrefix + 'toolbars-html.json');
      let zPaperToolbarButtons = {};
      for (let i = 0; i < htmlToolbarConfigInfo.toolbars.length; i++) {
        let toolbar = htmlToolbarConfigInfo.toolbars[i];
        if (toolbar.file) {
          let urlType = getUrlType(toolbar.file);
          if (urlType == "other") {
            toolbar.file = jsonPathPrefix + toolbar.file;
          }
          zPaperToolbarButtons[toolbar.name] = await getJson(toolbar.file);
        }
      }
      $().zpLib({
        action: "initilizeToolbar",
        buttons: zPaperToolbarButtons,
        toolbarWrapper: this.template.querySelector(".toolbarWrapper"),
        lwcService: {
          createElement: createElement,
          components: {
            'zpaper-page-buttons': zPaperPageButtons,
            'zpaper-zoom-buttons': zPaperZoomButtons,
            'zpaper-toolbar-button': zPaperToolbarButton,
            'zpaper-panel': zPaperPanels,
            'zpaper-edit-drop-down': zPaperEditDropDown,
            'zpaper-attach-files': zPaperAttachFiles,
            'lightning-combobox': lightningCombobox,
            'lightning-button': lightningButton,
            'lightning-button-icon': lightningButtonIcon,
            'lightning-button-menu': zPaperMenuButton,
            'zpaper-pages-picker': zPaperPagesPicker,
            'json-path-picker': jsonPathPicker
          }
        },
        eventService: {
          fireEvent: fireEvent,
          registerListener: registerListenerAndTrack,
          unregisterListener: unregisterListener,
          eventTypes: eventTypes,
          pageRef: this.pageRef
        },
        awsService: {
          'createCloudWatchObject': createCloudWatchObject,
          'sendLogsToAws': sendLogsToAws,
          'getNextSequenceToken': getNextSequenceToken,
          'saveLogs': saveLogs
        },
        sidebarService: {
          openSidebar: openSidebar,
          closeSidebar: closeSidebar,
          addChildToSidebar: addChildToSidebar,
          clearSidebar: clearSidebar,
          getSidebarDom: getSidebarDom
        }
      });
      let toolbarInitializedEvent = new CustomEvent(eventTypes.TOOLBAR_RESIZED, {
        detail: {
          toolbarResized: true,
          template: this.template
        },
        bubbles: true,
        cancelable: true
      });
      fireEvent(self.pageRef, eventTypes.TOOLBAR_RESIZED, toolbarInitializedEvent);
    } else {
      for (var j = 0; j < toolbarConfigInfo.toolbars.length; j++) {
        if (toolbarConfigInfo.toolbars[j].hasOwnProperty('condition') && window[toolbarConfigInfo.toolbars[j].condition]) {
          let functionName = toolbarConfigInfo.toolbars[j].condition;
          let returnVal = window[functionName](toolbarConfigInfo.toolbars[j].name, params.source);
          toolbarConfigInfo.toolbars[j].condition = returnVal;
        }
      }
      toolbarConfigInfo.toolbars = toolbarConfigInfo.toolbars.filter(function (check) {
        return check.condition != false; //&& check.hasOwnProperty('condition')
      });
      let defaultPdfUrl = toolbarConfigInfo.defaultPdfUrl;
      if (defaultPdfUrl) {
        defaultPdfUrl = defaultPdfUrl.startsWith("http") ? defaultPdfUrl : getFullUrl(defaultPdfUrl);
        defaultPdfUrl = encodeURIComponent(defaultPdfUrl);
      }
      let zPaperToolbarButtons = {};

      // let getUrlType = (url) => {
      //     if (/\//.test(url)) { //if the url has a "/" in it it is a relative url
      //         return "relative";
      //     } else if (/^https:\/\//.test(url)) { //if the url begins with https, it is a full URL
      //         return "full";
      //     } else { //other wise it is a file name from resources/configFiles/ folder
      //         return "other";
      //     }
      // };

      if (params.loadingDefaultPdf) {
        //if default pdf is loading , then load only the basic toolbar
        let openButton = await getJson(jsonPathPrefix + toolbarConfigInfo.basicToolbar);
        zPaperToolbarButtons = {
          "Open": openButton
        };
      } else if (params.loadBasicToolbar) {
        console.log("TestingDefaultPDF ** ");
        let openButton = await getJson(jsonPathPrefix + toolbarConfigInfo.basicToolbar);
        zPaperToolbarButtons = {
          "Open": openButton
        };
        if (!__g_requestedPdf && defaultPdfUrl) {
          let showDefaultPdfEvent = new CustomEvent(eventTypes.LOAD_PDF, {
            detail: {
              defaultPdfUrl: defaultPdfUrl,
              loadingDefaultPdf: true
            },
            bubbles: true,
            cancelable: true
          });
          fireEvent(self.pageRef, eventTypes.LOAD_PDF, showDefaultPdfEvent);
        }
      } else if (toolbarConfigInfo.extendedToolbars) {
        //toolbarConfigInfo.extendedToolbars will have the URL for the JSON file which contains the extended config
        let toolbars = await getJson(toolbarConfigInfo.extendedToolbars); //, true
        let toolbarNames = Object.keys(toolbars);
        toolbarNames.forEach(toolbarName => {
          zPaperToolbarButtons[toolbarName] = toolbars[toolbarName];
        });
      } else if (toolbarConfigInfo.toolbars) {
        // && toolbarConfigInfo.toolbars instanceof Array
        for (let i = 0; i < toolbarConfigInfo.toolbars.length; i++) {
          let toolbar = toolbarConfigInfo.toolbars[i];
          if (toolbar.file) {
            let urlType = getUrlType(toolbar.file);
            console.log("urlType : ", urlType);
            if (urlType == "other") {
              toolbar.file = jsonPathPrefix + toolbar.file;
            }
            zPaperToolbarButtons[toolbar.name] = await getJson(toolbar.file);
          }
        }
      }
      $(params.pdfPage).zpLib({
        action: "initilizeToolbar",
        canvas: $(params.pdfPage),
        overlayDiv: $(params.pdfPageOverlay),
        buttons: zPaperToolbarButtons,
        pdfInfo: params.pdfInfo,
        toolbarWrapper: this.template.querySelector(".toolbarWrapper"),
        pdfViewerMainPane: params.pdfViewerMainPane,
        lwcService: {
          createElement: createElement,
          components: {
            'zpaper-page-buttons': zPaperPageButtons,
            'zpaper-zoom-buttons': zPaperZoomButtons,
            // 'zpaper-upload-file-button': zPaperUploadFileButton,
            'zpaper-toolbar-button': zPaperToolbarButton,
            //'zpaper-personas': zPaperPersonas,
            'zpaper-panel': zPaperPanels,
            'zpaper-edit-drop-down': zPaperEditDropDown,
            'zpaper-attach-files': zPaperAttachFiles,
            'lightning-combobox': lightningCombobox,
            'lightning-button': lightningButton,
            'lightning-button-icon': lightningButtonIcon,
            'lightning-button-menu': zPaperMenuButton,
            'zpaper-pages-picker': zPaperPagesPicker,
            'json-path-picker': jsonPathPicker
          }
        },
        source: params.source,
        sourceUrl: params.sourceUrl,
        eventService: {
          fireEvent: fireEvent,
          registerListener: registerListenerAndTrack,
          unregisterListener: unregisterListener,
          eventTypes: eventTypes,
          pageRef: this.pageRef
        },
        awsService: {
          'createCloudWatchObject': createCloudWatchObject,
          'sendLogsToAws': sendLogsToAws,
          'getNextSequenceToken': getNextSequenceToken,
          'saveLogs': saveLogs
        },
        /*  googleService: {
              initializeGapi, 
              handleAuthClickOAuth2, 
              createPicker, 
              revokeGoogleDriveAccess, 
              getIsSignedIntoGoogle, 
              fileUpload,
              exportWalletToZPaperDrive,
              importWalletFromZPaperDrive
          },*/
        sidebarService: {
          openSidebar: openSidebar,
          closeSidebar: closeSidebar,
          addChildToSidebar: addChildToSidebar,
          clearSidebar: clearSidebar,
          getSidebarDom: getSidebarDom
        }
      });
      let toolbarInitializedEvent = new CustomEvent(eventTypes.TOOLBAR_RESIZED, {
        detail: {
          toolbarResized: true,
          template: this.template
        },
        bubbles: true,
        cancelable: true
      });
      fireEvent(self.pageRef, eventTypes.TOOLBAR_RESIZED, toolbarInitializedEvent);
    }
  }
  async initializeZpLibMobile(params) {
    clearSidebar();
    closeSidebar("left");
    closeSidebar("right");
    console.log("initializeZpLib start");
    let self = this;

    // CRN230426 override some styling in the toolbarWrapper class. ToDo: we need to make the background color configurable by partners.
    let $toolbarWrapper = $(this.template.querySelector(".toolbarWrapper"));
    __g_zPDF_formHelper__.mobileToolbar = $toolbarWrapper;
    $toolbarWrapper.css("background-color", "#025A9B");
    $toolbarWrapper.css("border", "none");
    let getJson = async url => {
      // let endpoint = getEndpoint(); // this is commented as it is not in use
      // let fullUrl = getFullUrl(url); // this is commented as it is not in use
      let jsonData = {};
      //AHS230124 - adding sf auth headers here
      let headers = {
        "Access-Control-Allow-Origin": "*",
        "Accept": "application/json"
      };
      headers = _objectSpread(_objectSpread({}, getDefaultHeaders()), headers);
      let ajaxSettings = {
        // "url": endpoint + fullUrl,
        "url": url,
        //using relative url to fetch json files
        "method": "GET",
        "async": false,
        "crossDomain": true,
        "headers": headers,
        success: data => {
          if (data) {
            jsonData = typeof data == "string" ? JSON.parse(data) : data;
          }
        },
        error: (jqxhr, status, error) => {
          console.error("An error has occured while loading external js, error", error, "status", status, "jqxhr", jqxhr);
        }
      };
      await $.ajax(ajaxSettings);
      return jsonData;
    };
    let jsonPathPrefix = "resources/configFiles/";
    let toolbarConfigInfoURL = jsonPathPrefix + "toolbars.json";
    let zPaperToolbars = {};
    let zPaperToolbarButtons = {};

    //AHS230124 - get toolbars.json from __g_zToolbarsURL, if it is defined
    if (__g_zToolbarsURL && !this.donotUseNodeRed) {
      toolbarConfigInfoURL = __g_zToolbarsURL;
    }
    let toolbarConfigInfo = await getJson(toolbarConfigInfoURL);
    if (params.htmlFile) {
      //AHS260506 - handle HTML files on mobile, same as desktop htmlFile branch
      let htmlToolbarConfigInfo = await getJson(jsonPathPrefix + 'toolbars-html.json');
      let zPaperToolbarButtonsHtml = {};
      let zPaperToolbarsHtml = {};
      for (let i = 0; i < htmlToolbarConfigInfo.toolbars.length; i++) {
        let toolbar = htmlToolbarConfigInfo.toolbars[i];
        zPaperToolbarsHtml[toolbar.name] = {};
        zPaperToolbarsHtml[toolbar.name].attributes = toolbar.attributes;
        if (toolbar.file) {
          let urlType = getUrlType(toolbar.file);
          if (urlType == "other") {
            toolbar.file = jsonPathPrefix + toolbar.file;
          }
          zPaperToolbarButtonsHtml[toolbar.name] = await getJson(toolbar.file);
        }
      }
      $().zpLib({
        isMobile: true,
        action: "initilizeToolbar",
        buttons: zPaperToolbarButtonsHtml,
        toolbars: zPaperToolbarsHtml,
        toolbarWrapper: this.template.querySelector(".toolbarWrapper"),
        lwcService: {
          createElement: createElement,
          components: {
            'zpaper-page-buttons': zPaperPageButtons,
            'zpaper-zoom-buttons': zPaperZoomButtons,
            'zpaper-toolbar-button': zPaperToolbarButton,
            'zpaper-panel': zPaperPanels,
            'zpaper-edit-drop-down': zPaperEditDropDown,
            'zpaper-attach-files': zPaperAttachFiles,
            'lightning-combobox': lightningCombobox,
            'lightning-button': lightningButton,
            'lightning-button-icon': lightningButtonIcon,
            'lightning-button-menu': zPaperMenuButton,
            'zpaper-pages-picker': zPaperPagesPicker,
            'json-path-picker': jsonPathPicker
          }
        },
        eventService: {
          fireEvent: fireEvent,
          registerListener: registerListenerAndTrack,
          unregisterListener: unregisterListener,
          eventTypes: eventTypes,
          pageRef: this.pageRef
        },
        awsService: {
          'createCloudWatchObject': createCloudWatchObject,
          'sendLogsToAws': sendLogsToAws,
          'getNextSequenceToken': getNextSequenceToken,
          'saveLogs': saveLogs
        },
        sidebarService: {
          openSidebar: openSidebar,
          closeSidebar: closeSidebar,
          addChildToSidebar: addChildToSidebar,
          clearSidebar: clearSidebar,
          getSidebarDom: getSidebarDom
        }
      });
      let toolbarInitializedEvent = new CustomEvent(eventTypes.TOOLBAR_RESIZED, {
        detail: {
          toolbarResized: true,
          template: this.template
        },
        bubbles: true,
        cancelable: true
      });
      fireEvent(self.pageRef, eventTypes.TOOLBAR_RESIZED, toolbarInitializedEvent);
      return; //AHS260506 - early return, HTML toolbar initialized
    }
    for (var j = 0; j < toolbarConfigInfo.toolbars.length; j++) {
      toolbarConfigInfo.toolbars[j].isVisible = true; //by default the toolbar is visible
      if (toolbarConfigInfo.toolbars[j].hasOwnProperty('condition') && window[toolbarConfigInfo.toolbars[j].condition]) {
        let functionName = toolbarConfigInfo.toolbars[j].condition;
        let returnVal = window[functionName](toolbarConfigInfo.toolbars[j].name, params.source);
        toolbarConfigInfo.toolbars[j].isVisible = returnVal; //AHS230425 - adding a new flag, instead of updating the condition attribute
      }
    }
    toolbarConfigInfo.toolbars = toolbarConfigInfo.toolbars.filter(function (toolbar) {
      if (toolbar.isVisible) {
        zPaperToolbars[toolbar.name] = {};
        zPaperToolbars[toolbar.name].attributes = toolbar.attributes;
      }
      return toolbar.isVisible;
    });
    let defaultPdfUrl = toolbarConfigInfo.defaultPdfUrl;
    if (defaultPdfUrl) {
      defaultPdfUrl = defaultPdfUrl.startsWith("http") ? defaultPdfUrl : getFullUrl(defaultPdfUrl);
      defaultPdfUrl = encodeURIComponent(defaultPdfUrl);
    }
    let openToolbar = {
      "name": "Open",
      "attributes": {
        "iconName": "utility:open",
        "variant": "container",
        "style": "--slds-c-icon-color-foreground: white; --slds-c-button-text-color-hover: white;"
      }
    };
    if (params.loadingDefaultPdf) {
      //if default pdf is loading , then load only the basic toolbar
      let openButton = await getJson(jsonPathPrefix + toolbarConfigInfo.basicToolbar);
      zPaperToolbarButtons = {
        "Open": openButton
      };
      zPaperToolbars["Open"] = openToolbar;
    } else if (params.loadBasicToolbar) {
      console.log("TestingDefaultPDF ** ");
      let openButton = await getJson(jsonPathPrefix + toolbarConfigInfo.basicToolbar);
      zPaperToolbarButtons = {
        "Open": openButton
      };
      zPaperToolbars["Open"] = openToolbar;
      if (!__g_requestedPdf && defaultPdfUrl) {
        let showDefaultPdfEvent = new CustomEvent(eventTypes.LOAD_PDF, {
          detail: {
            defaultPdfUrl: defaultPdfUrl,
            loadingDefaultPdf: true
          },
          bubbles: true,
          cancelable: true
        });
        fireEvent(self.pageRef, eventTypes.LOAD_PDF, showDefaultPdfEvent);
      }
    } else if (toolbarConfigInfo.extendedToolbars) {
      //toolbarConfigInfo.extendedToolbars will have the URL for the JSON file which contains the extended config
      let toolbars = await getJson(toolbarConfigInfo.extendedToolbars); //, true
      let toolbarNames = Object.keys(toolbars);
      toolbarNames.forEach(toolbarName => {
        zPaperToolbarButtons[toolbarName] = toolbars[toolbarName];
      });
    } else if (toolbarConfigInfo.toolbars) {
      // && toolbarConfigInfo.toolbars instanceof Array
      for (let i = 0; i < toolbarConfigInfo.toolbars.length; i++) {
        let toolbar = toolbarConfigInfo.toolbars[i];
        if (toolbar.file) {
          zPaperToolbarButtons[toolbar.name] = await getJson(jsonPathPrefix + toolbar.file);
        }
      }
    }
    $(params.pdfPage).zpLib({
      isMobile: true,
      action: "initilizeToolbar",
      canvas: $(params.pdfPage),
      overlayDiv: $(params.pdfPageOverlay),
      buttons: zPaperToolbarButtons,
      toolbars: zPaperToolbars,
      pdfInfo: params.pdfInfo,
      toolbarWrapper: this.template.querySelector(".toolbarWrapper"),
      pdfViewerMainPane: params.pdfViewerMainPane,
      lwcService: {
        createElement: createElement,
        components: {
          'zpaper-page-buttons': zPaperPageButtons,
          'zpaper-zoom-buttons': zPaperZoomButtons,
          //   'zpaper-upload-file-button': zPaperUploadFileButton,
          'zpaper-toolbar-button': zPaperToolbarButton,
          // 'zpaper-personas': zPaperPersonas,
          'zpaper-panel': zPaperPanels,
          'zpaper-edit-drop-down': zPaperEditDropDown,
          'zpaper-attach-files': zPaperAttachFiles,
          'lightning-combobox': lightningCombobox,
          'lightning-button': lightningButton,
          'lightning-button-icon': lightningButtonIcon,
          'lightning-button-menu': zPaperMenuButton,
          'zpaper-pages-picker': zPaperPagesPicker,
          'json-path-picker': jsonPathPicker
        }
      },
      source: params.source,
      sourceUrl: params.sourceUrl,
      eventService: {
        fireEvent: fireEvent,
        registerListener: registerListenerAndTrack,
        unregisterListener: unregisterListener,
        eventTypes: eventTypes,
        pageRef: this.pageRef
      },
      awsService: {
        'createCloudWatchObject': createCloudWatchObject,
        'sendLogsToAws': sendLogsToAws,
        'getNextSequenceToken': getNextSequenceToken,
        'saveLogs': saveLogs
      },
      /*   googleService: {
             initializeGapi,
             handleAuthClickOAuth2,
             createPicker,
             revokeGoogleDriveAccess,
             getIsSignedIntoGoogle,
             fileUpload,
             exportWalletToZPaperDrive,
             importWalletFromZPaperDrive
         },*/
      sidebarService: {
        openSidebar: openSidebar,
        closeSidebar: closeSidebar,
        addChildToSidebar: addChildToSidebar,
        clearSidebar: clearSidebar,
        getSidebarDom: getSidebarDom
      }
    });
    let toolbarInitializedEvent = new CustomEvent(eventTypes.TOOLBAR_RESIZED, {
      detail: {
        toolbarResized: true,
        template: this.template
      },
      bubbles: true,
      cancelable: true
    });
    fireEvent(self.pageRef, eventTypes.TOOLBAR_RESIZED, toolbarInitializedEvent);
  }
  initializeMarkup(params) {
    console.log("initializeMarkup in toolbar called - start");
    $(params.pdfPage).zpLib({
      action: "initializeMarkup",
      canvas: $(params.pdfPage),
      overlayDiv: $(params.pdfPageOverlay)
    });
    console.log("initializeMarkup in toolbar called - end");
  }
}
_registerDecorators(PdfViewerToolbar, {
  publicMethods: ["initializeZpLib", "initializeZpLibMobile", "initializeMarkup"],
  fields: ["pdfPage", "pdfPageOverlay", "pageRef", "donotUseNodeRed"]
});
export default _registerComponent(PdfViewerToolbar, {
  tmpl: _tmpl
});